import { render, staticRenderFns } from "./parameterTable.vue?vue&type=template&id=1fb783f9&scoped=true&"
import script from "./parameterTable.vue?vue&type=script&lang=js&"
export * from "./parameterTable.vue?vue&type=script&lang=js&"
import style0 from "./parameterTable.vue?vue&type=style&index=0&id=1fb783f9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb783f9",
  null
  
)

export default component.exports